// @module NVT.EventCalendarExt.MyEventModule
define('NVT.EventCalendarExt.MyEventModule.View'
,	[
	'nvt_eventcalendarext_myeventmodule.tpl'

	,	'NVT.EventCalendarExt.MyEventModule.SS2Model'

	,	'Backbone'
    ]
, function (
	nvt_eventcalendarext_myeventmodule_tpl

	,	MyEventModuleSS2Model

	,	Backbone
)
{
    'use strict';

	// @class NVT.EventCalendarExt.MyEventModule.View @extends Backbone.View
	return Backbone.View.extend({

		template: nvt_eventcalendarext_myeventmodule_tpl

	,	initialize: function (options) {

			this.options = options.container;
			this.plp = this.options.getComponent("PLP");

			if(this.plp.current_view.model.get('category') && this.plp.current_view.model.get('category').get('name'))
			{
				var getcatgname = this.plp.current_view.model.get('category').get('name');
				this.model = new MyEventModuleSS2Model();
				var self = this;
				this.model.fetch({async: false,data: {
					'getcatgname': getcatgname  
					}}).done(function(result) {
					if(result.status == '200')
					{
						self.eventCalenderJson = result;
						self.render();
					}				
				});
			}
		}

	,	events: {

		}

	,	bindings: {

		}

	, 	childViews: {

		}

		//@method getContext @return NVT.EventCalendarExt.MyEventModule.View.Context
	,	getContext: function getContext()
		{
			//@class NVT.EventCalendarExt.MyEventModule.View.Context
			this.eventCalenderJson = this.eventCalenderJson || ''
			return {
				eventCalenderJson: encodeURIComponent( JSON.stringify(this.eventCalenderJson))
			};
		}
	});
});
